import React, { useState, useEffect } from "react";
import { Link, Route, useParams } from "react-router-dom";
import styles from "./ProfilePublic.module.css";
import block from "../assets/block.png";
import translations from "./translation.js";


const OtherProfileButtons = () => {

  const currentLanguage = localStorage.getItem('selectedLanguage') || "en";
  const { userID } = useParams();
  const [connection, setConnection] = useState(0);
  const [connectionID, setConID] = useState(null);
  const [revConID, setRevConID] = useState(null);
  const [priv, setPriv] = useState(false)
  const [toUserID, setToUserID] = useState(null);
  const [fromUserID, setFromUserID] = useState(null);
  const [rerender, setRerender] = useState(false);
  

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const userResponse = await fetch(
          `${process.env.REACT_APP_API_PATH}/users/${userID}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            },
          }
        );
        if (userResponse.ok) {
          const userResult = await userResponse.json();
          setPriv(userResult.attributes.MakePrivate);
        } else {
          console.error('Failed to fetch user data');
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };
    fetchUserData();
  }, []);



  const checkConnections = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_PATH}/connections?fromUserID=${sessionStorage.getItem("user")}&toUserID=${userID}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      });
      if (response.ok) {
        const data = await response.json();
        if (data[0].length !== 0) {
          for (let i = 0; i < Object.keys(data[0]).length; i++) {
            if (data[0][i].attributes.connection) {
              setConID(data[0][i].id)
              setConnection(data[0][i].attributes.connection)
              setToUserID(data[0][i].toUser.id);
              setFromUserID(data[0][i].fromUser.id);
            }
          }
        }
      } else {
        throw new Error('Failed to fetch connections');
      }
    } catch (error) {
      console.error('Error checking connections:', error);
    }
  };

  const checkReverseConnections = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_PATH}/connections?fromUserID=${userID}&toUserID=${sessionStorage.getItem("user")}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      });
      if (response.ok) {
        const data = await response.json();
        if (data[0].length !== 0) {
          for (let i = 0; i < Object.keys(data[0]).length; i++) {
            if (data[0][i].attributes.connection) {
              setRevConID(data[0][i].id)
            }
          }
        }
      } else {
        throw new Error('Failed to fetch connections');
      }
    } catch (error) {
      console.error('Error checking connections:', error);
    }
  };

  useEffect(() => {
    checkConnections();
  }, [userID]); // Add userID as a dependency
  
  useEffect(() => {
    checkReverseConnections();
  }, [userID]); // Add userID as a dependency 

  const makeConnection = async (stat) => {
    try {
      await Promise.all([checkConnections(), checkReverseConnections()]);
      console.log(connectionID, revConID); // Now logs should show updated values
      if (connectionID && revConID) {
        patchConnection(stat);
      }
      else {
          fetch(process.env.REACT_APP_API_PATH + "/connections", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + sessionStorage.getItem("token"),
            },
            body: JSON.stringify({
              toUserID: userID,
              fromUserID: sessionStorage.getItem("user"),
              attributes: { connection: 0 - stat },
            }),
          })
            .then(() => {
              setConnection(0 - stat);
              setRerender(!rerender); // Trigger rerender
            })
            .catch((error) => {
              console.error("Error making connection:", error);
            });
        
          fetch(process.env.REACT_APP_API_PATH + "/connections", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + sessionStorage.getItem("token"),
            },
            body: JSON.stringify({
              toUserID: sessionStorage.getItem("user"),
              fromUserID: userID,
              attributes: { connection: stat },
            }),
          })
            .then(() => {
              console.log("Connection made successfully");
              setRerender(!rerender); // Trigger rerender
            })
            .catch((error) => {
              console.error("Error making connection:", error);
            });
        }
      } catch (error) {
        console.error("Error making connection:", error);
      }
  };
  

  const patchConnection = (stat) => {
    let rev = 0-stat;
    console.log("stat",stat,rev)
    console.log("conn",connectionID,revConID)
    fetch(process.env.REACT_APP_API_PATH + "/connections/" + connectionID, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify({
        attributes: { connection: rev},
      }),
    })
      .then(() => {
        setConnection(rev);
        setRerender(!rerender); // Trigger rerender
      }
      );
      fetch(process.env.REACT_APP_API_PATH + "/connections/" + revConID, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify({
          attributes: { connection: stat},
        }),
      })
      .then(() => {
        checkReverseConnections();
        checkConnections();
        console.log("Connection made successfully");
        setRerender(!rerender); // Trigger rerender
      })
  }

  console.log(connection)
  
  //block
  if (connection === -3) {
    return (
      <button onClick={() => makeConnection(0)} className={styles.blockedBtn}>{translations[currentLanguage].unblock}</button>
    );
  }
  if (connection === 3) {
      return (
        <button disabled className={styles.blockedBtn}>{translations[currentLanguage].block}</button>
      );
  }
  if (priv) {
    //private follow
    if (connection === 1) {
      return (
        <>
          <button onClick={() => makeConnection(5)} className={styles.reqfollowBtn}>{translations[currentLanguage].request_to_follow}</button>
        <button onClick={() => makeConnection(3)} className={styles.messageBtn}>
          <span style={{textDecoration: "none", color: "white"}}>{translations[currentLanguage].block}</span>
        </button>
        </>
      );
    }
    if (connection === -1) {
      // return unfollow
      return (
        <>
          <button onClick={() => makeConnection(0)} className={styles.unfollowBtn}>{translations[currentLanguage].unfollow}</button>
        <button onClick={() => makeConnection(3)} className={styles.messageBtn}>
          <span style={{textDecoration: "none", color: "white"}}>{translations[currentLanguage].block}</span>
        </button>
        </>
      );
    } 
    if (connection === 0) {
          return (
            <>
              <button onClick={() => makeConnection(2)} className={styles.reqfollowBtn}>{translations[currentLanguage].request_to_follow}</button>
            <button onClick={() => makeConnection(3)} className={styles.messageBtn}>
              <span style={{textDecoration: "none", color: "white"}}>{translations[currentLanguage].block}</span>
            </button>
            </>
          );
        }
      }
  
  // following
  if (connection === -1) {
    // return unfollow
    return (
      <>
        <button onClick={() => makeConnection(0)} className={styles.unfollowBtn}>{translations[currentLanguage].unfollow}</button>
        <button onClick={() => makeConnection(3)} className={styles.messageBtn}>
          <span style={{textDecoration: "none", color: "white"}}>{translations[currentLanguage].block}</span>
        </button>
      </>
    );
  } 
  if (connection === 1) {
    return (
      <>
        <button onClick={() => makeConnection(4)} className={styles.followBtn}>{translations[currentLanguage].follow}</button>
        <button onClick={() => makeConnection(3)} className={styles.messageBtn}>
          <span style={{textDecoration: "none", color: "white"}}>{translations[currentLanguage].block}</span>
        </button>
      </>
    );
  }
  if (connection === -4 || connection === 4) {
    // return unfollow
    return (
      <>
        <button onClick={() => makeConnection(-1)} className={styles.unfollowBtn}>{translations[currentLanguage].unfollow}</button>
        <button onClick={() => makeConnection(3)} className={styles.messageBtn}>
          <span style={{textDecoration: "none", color: "white"}}>{translations[currentLanguage].block}</span>
        </button>
      </>
    );
  } 
  if (connection === 2) {
    return (
      <>
        <button onClick={() => makeConnection(-1)} className={styles.reqfollowBtn}>{translations[currentLanguage].accpet_request}</button>
        <button onClick={() => makeConnection(3)} className={styles.messageBtn}>
        <span style={{textDecoration: "none", color: "white"}}>{translations[currentLanguage].block}</span>
      </button>
      </>
    );
  }
  if (connection === -2) {
    return (
      <>
        <button onClick={() => makeConnection(0)} className={styles.reqfollowBtn}>{translations[currentLanguage].cancel_request}</button>
        <button onClick={() => makeConnection(3)} className={styles.messageBtn}>
        <span style={{textDecoration: "none", color: "white"}}>{translations[currentLanguage].block}</span>
      </button>
      </>
    );
  } 
  if (connection === 5) {
    return (
      <>
        <button onClick={() => makeConnection(4)} className={styles.reqfollowBtn}>{translations[currentLanguage].accpet_request}</button>
      <button onClick={() => makeConnection(3)} className={styles.messageBtn}>
        <span style={{textDecoration: "none", color: "white"}}>{translations[currentLanguage].block}</span>
      </button>
      </>
    );
  }
  if (connection === -5) {
    return (
      <>
        <button onClick={() => makeConnection(1)} className={styles.reqfollowBtn}>{translations[currentLanguage].cancel_request}</button>
      <button onClick={() => makeConnection(3)} className={styles.messageBtn}>
        <span style={{textDecoration: "none", color: "white"}}>{translations[currentLanguage].block}</span>
      </button>
      </>
    );
  }
  if (connection === 0) {
    // return follow
    return (
      <>
        <button onClick={() => makeConnection(1)} className={styles.followBtn}>{translations[currentLanguage].follow}</button>
        {/* <button className={styles.messageBtn}><Link to="/*" style={{textDecoration: "none", color: "white"}}>Message</Link></button> */}
        <button onClick={() => makeConnection(3)} className={styles.messageBtn}>
          <span style={{textDecoration: "none", color: "white"}}>{translations[currentLanguage].block}</span>
        </button>
      </>
    );
  }
};

export default OtherProfileButtons;
